import postAPI from './postAPI.js'

export default async function postCompleteUpload(data) {
    const response = await postAPI('taskinstances/steps/upload/complete', data);
    return response;
}
